import { Typography } from "@circle-react-uikit/Typography";
import { omit } from "lodash";
import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";

import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";

export interface FormParagraphBlockProps extends ComponentPropsWithRef<"div"> {
  value?: string;
}

export const FormParagraphBlock = forwardRef<
  HTMLDivElement,
  FormParagraphBlockProps
>(({ value, className, ...rest }, ref) => {
  const elementProps = omit(rest, ["blockPath"]);
  return (
    <div ref={ref} className={classNames("mb-2", className)} {...elementProps}>
      <Typography.BodySm>
        {value || t("builder_ui.prop_type.text_content_empty")}
      </Typography.BodySm>
    </div>
  );
});

FormParagraphBlock.displayName = "FormParagraphBlock";
